const get = state => state.transversalView;

export const getTransversalViewDataSelector = state => get(state);
export const getKPYSTransversalDataSelector = state => state.KPYsTransversalViewHandler;
